import { useEffect } from 'react';
/**
 * Applies a filter to a viewport.
 * @param viewportData Viewport to filter
 * @param filter Filter to apply
 */
export function useViewportFilter(viewportData, filter) {
  var applyFiltersAndRefresh = viewportData.applyFiltersAndRefresh;
  useEffect(() => {
    applyFiltersAndRefresh(filter);
  }, [applyFiltersAndRefresh, filter]);
}
export default useViewportFilter;
//# sourceMappingURL=useViewportFilter.js.map